import React, { useEffect, useState } from "react";

const CurlyArrow = () => {
  const [showArrow, setShowArrow] = useState(true);

  useEffect(() => {
    // Show the arrow when the component mounts
    setShowArrow(true);

    // Hide the arrow after 3 seconds
    const timer = setTimeout(() => {
      setShowArrow(false);
    }, 3000);

    // Cleanup the timer when component unmounts
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {showArrow && (
        
        <img
          className="absolute animate-pulse bottom-[32vh] left-[5vw] lg:top-3 lg:left-[30vw] w-32 h-32 z-[9999]"
          src={require("../../assets/yellow-arrow.png")}
          alt="Curly Arrow"
        />
      )}
    </>
  );
};

export default CurlyArrow;